module.exports = __webpack_public_path__ + "static/MuseoSans-500-1a66056cc7dacd31ea21f5e3476584d2.woff2";